import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import EditMyContactModal from "./editProfileModals/EditMyContactModal";

function MyContact(props) {
    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);
    const [ newPlanModal, setNewPlanModal ] = useState(false);
    const toggleNewPlanModal = () => setNewPlanModal(!newPlanModal);
    var { profile } = props.store
    var { contactInfo } = profile
    return (
    <div className="mg-t-20" >
        <div className="card" >
        <div className="card-header">
            <div className="card-header-left">
                <h5>Contact Information</h5>
            </div>
            <div className="card-header-right">
                <ul className="row" >                        
                    <li><i className="far fa-edit" onClick={toggleNewPlanModal}></i></li>   
                    <li><i className={collapse ? "fa fa-chevron-down" : "fa fa-chevron-up"} onClick={toggle}></i></li>                                 
                    <EditMyContactModal modal={newPlanModal} toggle={toggleNewPlanModal} contactInfo={contactInfo} />  
                </ul>                    
            </div>
        </div>         
        <Collapse isOpen={!collapse}> 
            <hr className="mg-l-20" ></hr>            
            <div className="card-block">
                <div className="row ">
                    <div className="row mg-l-5 pd-r-20 b-r-border mg-r-20 card-list-subheader" >
                        <div><i className="fas fa-location-arrow card-list-icon" ></i></div>
                        <div>
                            <div>{contactInfo.addressField1} </div>
                            {contactInfo.addressField2 ? <div>{contactInfo.addressField2}</div>: null}
                            {contactInfo.addressField3 ? <div>{contactInfo.addressField3}</div>: null}
                            <div>{contactInfo.city + ", " + contactInfo.pin}</div>
                            <div>{contactInfo.state + ", " + contactInfo.country}</div>
                        </div>
                    </div>
                    <div className="row mg-l-5 pd-r-20 b-r-border mg-r-20 card-list-subheader" >
                        <div><i className="far fa-envelope card-list-icon" ></i></div>
                        <div>{contactInfo.email}</div>
                    </div>
                    <div >
                        <div className="row mg-l-5 mg-b-15 card-list-subheader" >
                            <div><i className="fas fa-phone-alt card-list-icon" ></i></div>
                            <div>{contactInfo.phone}
                            <span className="active-badge-static bg-c-primary-active"></span>
                            </div>
                        </div>
                        {contactInfo.phone2 ? <div className="row mg-l-5 card-list-subheader" >
                        <div><i className="fas fa-phone-alt card-list-icon" ></i></div>
                        <div>{contactInfo.phone2}</div>
                        </div>
                        : null}
                    </div>
                </div>
            </div>
        </Collapse>
    </div>
    </div>
        
    );
  }

export default MyContact